import { useState } from 'react'
import EditIcon from '@material-ui/icons/Edit'
import Button from '@material-ui/core/Button'
import Dialog from '@material-ui/core/Dialog'
import DialogTitle from '@material-ui/core/DialogTitle'
import DialogContent from '@material-ui/core/DialogContent'
import DialogActions from '@material-ui/core/DialogActions'
import { KeyboardDatePicker } from '@material-ui/pickers'
import { useField } from 'react-final-form'
import { dateTimeToDate } from '../../../utils/dates'
import { useTranslation } from 'react-i18next'

type Props = {
  label: string
  dateFieldName: string
}

export const SectionTitleWithDate = ({ label, dateFieldName }: Props) => {
  const { t } = useTranslation('sessionNotesSection')
  const {
    input: { value, onChange }
  } = useField(dateFieldName)

  const [open, setOpen] = useState(false)
  const [selectedDate, setSelectedDate] = useState<Date | null>(null)

  const handleOpen = () => {
    setSelectedDate(value ? new Date(value) : new Date())
    setOpen(true)
  }

  const handleClose = () => {
    setOpen(false)
  }

  const handleConfirm = () => {
    onChange(selectedDate?.toISOString() ?? null)
    setOpen(false)
  }

  const formattedDate = dateTimeToDate(value)

  return (
    <div style={{ display: 'inline-flex', alignItems: 'center', gap: 4 }}>
      {label}
      {formattedDate && <> {formattedDate}</>}
      <EditIcon
        style={{ fontSize: 14, cursor: 'pointer', marginLeft: 2 }}
        onClick={handleOpen}
      />
      <Dialog open={open} onClose={handleClose}>
        <DialogTitle>{t('changeDate')}</DialogTitle>
        <DialogContent>
          <KeyboardDatePicker
            value={selectedDate}
            onChange={(date) => setSelectedDate(date)}
            format="dd-MM-yyyy"
            invalidDateMessage={t('invalidDateMessage')}
          />
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose} color="secondary">
            {t('cancel')}
          </Button>
          <Button onClick={handleConfirm} color="primary" autoFocus>
            {t('confirm')}
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  )
}
